import tw from 'tailwind-styled-components'
import {Emoji, EmojiProps} from '@components/common/base/emoji'
import {DivWithHint} from '@components/common/hint/hint'
import {UserBrowser} from '@containers/hooks'

export const TwChatReaction = tw(DivWithHint)`
  group/reaction
  relative
  isolate
  cursor-pointer
  select-none
  flex-none
  flex
  flex-row
  flex-nowrap
  gap-4
  py-4
  px-8
  w-fit
  h-24
  items-center
`

export const TwBackground = tw.div<{$reacted?: boolean}>`
  absolute
  -z-10
  rounded-4
  top-0
  left-0
  right-0
  bottom-0
  group-hover/reaction:bg-reaction-hover
  group-hover/reaction:opacity-[0.7]
  group-active/reaction:bg-action-default
  group-active/reaction:opacity-[0.7]
  ${p =>
    p.$reacted
      ? 'bg-action-default opacity-[0.7]'
      : 'bg-reaction opacity-[0.15]'}
`

export const TwEmoji = tw<{$browser?: UserBrowser} & EmojiProps>(Emoji)`
  flex
  flex-none
  items-center
  h-16
  w-16
  leading-4
  ${p => (p.$browser === 'Safari' ? 'text-12' : 'text-16')}
`

export const TwCount = tw.div<{$reacted?: boolean}>`
  flex-none
  text-12
  leading-4
  group-hover/reaction:text-secondary
  group-active/reaction:text-invert
  ${p => (p.$reacted ? 'text-invert' : 'text-secondary')}
`
